module.exports = __webpack_public_path__ + "media/images/lb/403-4c210e35e84e40246fe74b8b58f75894.svg";